import { MemberPaymentActionType } from 'modules/common/components/Payment/MemberPaymentContext/mappers';

export interface StripeMessage {
    firstTime: boolean;
    isSuccess: boolean;
    message: string;
    messageLine1: string;
    messageLine2: string;
}

export interface MemberPaymentState {
    isPaymentModalOpen: boolean;
    stripeTokenId: string;
    isToSChecked: boolean;
    stripeMessage: StripeMessage;
    isUpdating: boolean;
}

export type MemberPaymentAction =
    | { type: typeof MemberPaymentActionType.OPEN_MODAL }
    | { type: typeof MemberPaymentActionType.CLOSE_MODAL }
    | { type: typeof MemberPaymentActionType.SET_TOKEN; payload: string }
    | { type: typeof MemberPaymentActionType.SET_TOS_CHECKED; payload: boolean }
    | { type: typeof MemberPaymentActionType.SET_MESSAGE; payload: Partial<StripeMessage> }
    | { type: typeof MemberPaymentActionType.RESET_MESSAGE }
    | { type: typeof MemberPaymentActionType.SET_UPDATING; payload: boolean }
    | { type: typeof MemberPaymentActionType.RESET };

interface MemberPaymentActions {
    openPaymentModal: () => void;
    closePaymentModal: () => void;
    setStripeTokenId: (id: string) => void;
    setIsToSChecked: (checked: boolean) => void;
    setStripeMessage: (msg: Partial<StripeMessage>) => void;
    resetStripeMessage: () => void;
    updatePayment: () => Promise<void>;
}

export interface MemberPaymentContextProps extends MemberPaymentState, MemberPaymentActions {
    hasPaymentIssue: boolean;
    isPaymentPending: boolean;
}

export const initialStripeMessage: StripeMessage = {
    firstTime: true,
    isSuccess: false,
    message: '',
    messageLine1: '',
    messageLine2: '',
};

export const initialMemberPaymentState: MemberPaymentState = {
    isPaymentModalOpen: false,
    stripeTokenId: '',
    isToSChecked: false,
    stripeMessage: initialStripeMessage,
    isUpdating: false,
};
